import React, { Component } from 'react';
import Tibbit_base from '@appblocks/frontend/client/Components/TPP/Tibbit_base';

export default class Tibbit_hybrid_wide extends Tibbit_base {
    constructor(props: any) {
        super(props);
        this.width = 146;
        this.height = 96.63;
    }

    render() {
        return (
            <g id="hybrid_wide" {...this.props} className="tibbit">
                <rect className="draggable" x="-46.05" y="0" width="146" height="96.63" />
                <g transform="translate(-46.05, -2)">
                    <rect className="pcbColor" x="40.525" y="13.132" width="5.525" height="76.904" />
                    <path id="color" className={`moduleColor_${this.props.category}`} d="M46.051,2.135v98.897H147.93V2.135H46.051z" />
                    <polygon className="moduleColor_connector" points="44.634,6.957 44.634,1.864 9.877,1.864 9.877,3.265 &#10;&#9;&#9;2.258,3.265 2.258,1.864 0,1.864 0,100.991 2.258,100.991 2.258,99.821 9.877,99.821 9.877,101.032 44.634,101.032 44.634,96.579 &#10;&#9;&#9;40.665,96.579 40.665,6.957 " />

                    <path className="recess" d="M143.459,5.282h-5.26v4.21h5.26v2.82h-5.26v3.94h5.26v2.819h-5.26&#10;&#9;&#9;v3.94h5.26v2.82h-5.26v3.939h5.26v2.82h-5.26v3.939h5.26v2.82h-5.26v3.94h5.26v2.819h-5.26v3.94h5.26v2.819h-5.26v3.94h5.26v2.82&#10;&#9;&#9;h-5.26v3.939h5.26v2.82h-5.26v3.94h5.26v2.819h-5.26v3.94h5.26v2.819h-5.26v3.94h5.26v2.82h-5.26v3.939h5.26v2.82h-5.26v4.21h5.26&#10;&#9;&#9;h4.461h0.01V5.282H143.459z M50.501,5.282H46.04v92.36h4.461h0.01h5.26v-4.21h-5.26h-0.01v-2.82h0.01h5.26v-3.939h-5.26h-0.01v-2.82&#10;&#9;&#9;h0.01h5.26v-3.94h-5.26h-0.01v-2.819h0.01h5.26v-3.94h-5.26h-0.01v-2.819h0.01h5.26v-3.94h-5.26h-0.01v-2.82h0.01h5.26v-3.939h-5.26&#10;&#9;&#9;h-0.01v-2.82h0.01h5.26v-3.94h-5.26h-0.01v-2.819h0.01h5.26v-3.94h-5.26h-0.01v-2.819h0.01h5.26v-3.94h-5.26h-0.01v-2.82h0.01h5.26&#10;&#9;&#9;v-3.939h-5.26h-0.01v-2.82h0.01h5.26v-3.939h-5.26h-0.01v-2.82h0.01h5.26v-3.94h-5.26h-0.01v-2.819h0.01h5.26v-3.94h-5.26h-0.01&#10;&#9;&#9;v-2.82h0.01h5.26v-4.21h-5.26H50.501z" />

                    <rect className="recess" x="2.258" y="3.265" width="7.62" height="96.556" />

                    <path className="labelColor" d="M133.922,97.872l0.01-92.349l-65.23-0.012l-8.66,8.449l0.009,83.921L133.922,97.872z" />

                    <g id="label">
                        <text transform="matrix(1 0 0 1 66.9113 17)" className="label" id="num">{this.props.num}</text>
                        <text transform="matrix(1 0 0 1 67.2663 28.2717)" className="desc" id="desc">
                            {this.renderDescriptions()}
                        </text>
                    </g>
                    <g id="lines">
                        {this.renderLines()}
                    </g>

                    <polygon className="tibbitStroke" points="46.051,2.135 46.051,13.132 40.665,13.132 40.665,6.957 &#10;&#9;&#9;44.634,6.957 44.634,1.864 9.877,1.864 9.877,3.265 2.258,3.265 2.258,1.864 0,1.864 0,100.991 2.258,100.991 2.258,99.821 &#10;&#9;&#9;9.877,99.821 9.877,101.032 44.634,101.032 44.634,96.579 40.665,96.579 40.665,90.036 46.051,90.036 46.051,101.032 &#10;&#9;&#9;147.93,101.032 147.93,2.135 " />
                </g>
                <g transform="translate(-46.05)">
                    {this.renderWiring()}
                </g>
            </g>
        );
    }
}
